import { Heading } from "."

export const IconText = ({ icon, text }) => {
    return <Heading {...{ icon, text, level: "h5" }} />
}
